// ? [REVISIT] manually review this file
//@ts-nocheck

// *This file will be loaded only within page template

import '../../styles/components/responsive-tables.scss';

// Make iFrames responsive
const slate = window.slate || {};
window.theme = window.theme || {};
slate.rte = {
  wrapTable() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },
  iframeReset() {
    const $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    const $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');
    $iframeVideo.each(function () {
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // eslint-disable-next-line no-self-assign
      this.src = this.src;
    });
  },
};
slate.rte.iframeReset();
